/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * Clovie API
 * Salon management API
 * OpenAPI spec version: 0.0.1
 */
import { useInfiniteQuery, useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type {
  DeleteMarketingGoogleRankingKeywordsId200,
  DeleteMarketingGoogleRankingPostsPostId200,
  GetMarketingGoogleRankingKeywords200,
  GetMarketingGoogleRankingOverview200,
  GetMarketingGoogleRankingPhotos200,
  GetMarketingGoogleRankingPhotosParams,
  GetMarketingGoogleRankingPhotosStatus200,
  GetMarketingGoogleRankingPhotosStatusParams,
  GetMarketingGoogleRankingPhotosSummary200,
  GetMarketingGoogleRankingPostEditorOptions200,
  GetMarketingGoogleRankingPostSettings200,
  GetMarketingGoogleRankingPosts200,
  GetMarketingGoogleRankingPostsParams,
  GetMarketingGoogleRankingProfile200,
  GetMarketingGoogleRankingRank200,
  GetMarketingGoogleRankingRankParams,
  GetMarketingGoogleRankingUpNext200,
  PatchMarketingGoogleRankingPostSettings200,
  PatchMarketingGoogleRankingPostSettingsBody,
  PatchMarketingGoogleRankingPostsPostId200,
  PatchMarketingGoogleRankingPostsPostIdBody,
  PostMarketingGoogleRankingKeywords201,
  PostMarketingGoogleRankingKeywordsBody,
  PostMarketingGoogleRankingKeywordsIdScan202,
  PostMarketingGoogleRankingPhotos201,
  PostMarketingGoogleRankingPhotosBody,
  PostMarketingGoogleRankingPhotosPhotoIdRemove200,
  PostMarketingGoogleRankingPhotosPhotoIdRestore200,
  PostMarketingGoogleRankingPhotosPhotoIdRetry200,
  PostMarketingGoogleRankingPhotosPhotoIdSkipSlot200,
  PostMarketingGoogleRankingPhotosPhotoIdUseAnyway200,
  PostMarketingGoogleRankingPhotosSendNow202,
  PostMarketingGoogleRankingPhotosSendNowBody,
  PostMarketingGoogleRankingPosts201,
  PostMarketingGoogleRankingPostsBody,
  PostMarketingGoogleRankingPostsPostIdApprove200,
  PostMarketingGoogleRankingPostsPostIdApproveBody,
  PostMarketingGoogleRankingPostsPostIdUnschedule200,
  PostMarketingGoogleRankingProfileHolidayHours201,
  PostMarketingGoogleRankingProfileHolidayHoursBody,
  PostMarketingGoogleRankingProfileRefresh202,
  PostMarketingGoogleRankingProfileSuggestionsApproveAll200,
  PostMarketingGoogleRankingProfileSuggestionsApproveAllBody,
  PostMarketingGoogleRankingProfileSuggestionsIdApprove200,
  PostMarketingGoogleRankingProfileSuggestionsIdApproveBody,
  PostMarketingGoogleRankingProfileSuggestionsIdSkip200,
} from '.././schemas';

import { customInstance } from '../../axios-instance';

/**
 * @summary Google profile score (graded items, groups, benchmark) and open/sent/failed fixes (database only)
 */
export const getMarketingGoogleRankingProfile = (signal?: AbortSignal) => {
  return customInstance<GetMarketingGoogleRankingProfile200>({
    url: `/marketing/google-ranking/profile`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingGoogleRankingProfileInfiniteQueryKey = () => {
  return ['infinite', `/marketing/google-ranking/profile`] as const;
};

export const getGetMarketingGoogleRankingProfileQueryKey = () => {
  return [`/marketing/google-ranking/profile`] as const;
};

export const getGetMarketingGoogleRankingProfileInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingProfile>>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getMarketingGoogleRankingProfile>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingGoogleRankingProfileInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingGoogleRankingProfile>>> = ({
    signal,
  }) => getMarketingGoogleRankingProfile(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingGoogleRankingProfile>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingGoogleRankingProfileInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingGoogleRankingProfile>>
>;
export type GetMarketingGoogleRankingProfileInfiniteQueryError = void;

export function useGetMarketingGoogleRankingProfileInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingProfile>>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingProfile>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleRankingProfile>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleRankingProfile>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingProfileInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingProfile>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingProfile>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleRankingProfile>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleRankingProfile>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingProfileInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingProfile>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingProfile>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Google profile score (graded items, groups, benchmark) and open/sent/failed fixes (database only)
 */

export function useGetMarketingGoogleRankingProfileInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingProfile>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingProfile>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingGoogleRankingProfileInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingGoogleRankingProfileQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingProfile>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getMarketingGoogleRankingProfile>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingGoogleRankingProfileQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingGoogleRankingProfile>>> = ({
    signal,
  }) => getMarketingGoogleRankingProfile(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingGoogleRankingProfile>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingGoogleRankingProfileQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingGoogleRankingProfile>>
>;
export type GetMarketingGoogleRankingProfileQueryError = void;

export function useGetMarketingGoogleRankingProfile<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingProfile>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingGoogleRankingProfile>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleRankingProfile>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleRankingProfile>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingProfile<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingProfile>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingGoogleRankingProfile>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleRankingProfile>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleRankingProfile>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingProfile<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingProfile>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingGoogleRankingProfile>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Google profile score (graded items, groups, benchmark) and open/sent/failed fixes (database only)
 */

export function useGetMarketingGoogleRankingProfile<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingProfile>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingGoogleRankingProfile>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingGoogleRankingProfileQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingGoogleRankingProfileSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingProfile>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getMarketingGoogleRankingProfile>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingGoogleRankingProfileQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingGoogleRankingProfile>>> = ({
    signal,
  }) => getMarketingGoogleRankingProfile(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingGoogleRankingProfile>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingGoogleRankingProfileSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingGoogleRankingProfile>>
>;
export type GetMarketingGoogleRankingProfileSuspenseQueryError = void;

export function useGetMarketingGoogleRankingProfileSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingProfile>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingProfile>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingProfileSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingProfile>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingProfile>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingProfileSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingProfile>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingProfile>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Google profile score (graded items, groups, benchmark) and open/sent/failed fixes (database only)
 */

export function useGetMarketingGoogleRankingProfileSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingProfile>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingProfile>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingGoogleRankingProfileSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Queue a fresh read of the Google profile ("Check again"; 1 per 10 minutes per salon)
 */
export const postMarketingGoogleRankingProfileRefresh = (signal?: AbortSignal) => {
  return customInstance<PostMarketingGoogleRankingProfileRefresh202>({
    url: `/marketing/google-ranking/profile/refresh`,
    method: 'POST',
    signal,
  });
};

export const getPostMarketingGoogleRankingProfileRefreshMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingGoogleRankingProfileRefresh>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingGoogleRankingProfileRefresh>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['postMarketingGoogleRankingProfileRefresh'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingGoogleRankingProfileRefresh>>,
    void
  > = () => {
    return postMarketingGoogleRankingProfileRefresh();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingGoogleRankingProfileRefreshMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingGoogleRankingProfileRefresh>>
>;

export type PostMarketingGoogleRankingProfileRefreshMutationError = void;

/**
 * @summary Queue a fresh read of the Google profile ("Check again"; 1 per 10 minutes per salon)
 */
export const usePostMarketingGoogleRankingProfileRefresh = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingGoogleRankingProfileRefresh>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingGoogleRankingProfileRefresh>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getPostMarketingGoogleRankingProfileRefreshMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Answer an upcoming holiday — saved in the salon calendar (online booking follows it) and sent to Google as holiday hours
 */
export const postMarketingGoogleRankingProfileHolidayHours = (
  postMarketingGoogleRankingProfileHolidayHoursBody: PostMarketingGoogleRankingProfileHolidayHoursBody,
  signal?: AbortSignal
) => {
  return customInstance<PostMarketingGoogleRankingProfileHolidayHours201>({
    url: `/marketing/google-ranking/profile/holiday-hours`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postMarketingGoogleRankingProfileHolidayHoursBody,
    signal,
  });
};

export const getPostMarketingGoogleRankingProfileHolidayHoursMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingGoogleRankingProfileHolidayHours>>,
    TError,
    { data: PostMarketingGoogleRankingProfileHolidayHoursBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingGoogleRankingProfileHolidayHours>>,
  TError,
  { data: PostMarketingGoogleRankingProfileHolidayHoursBody },
  TContext
> => {
  const mutationKey = ['postMarketingGoogleRankingProfileHolidayHours'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingGoogleRankingProfileHolidayHours>>,
    { data: PostMarketingGoogleRankingProfileHolidayHoursBody }
  > = (props) => {
    const { data } = props ?? {};

    return postMarketingGoogleRankingProfileHolidayHours(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingGoogleRankingProfileHolidayHoursMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingGoogleRankingProfileHolidayHours>>
>;
export type PostMarketingGoogleRankingProfileHolidayHoursMutationBody =
  PostMarketingGoogleRankingProfileHolidayHoursBody;
export type PostMarketingGoogleRankingProfileHolidayHoursMutationError = void;

/**
 * @summary Answer an upcoming holiday — saved in the salon calendar (online booking follows it) and sent to Google as holiday hours
 */
export const usePostMarketingGoogleRankingProfileHolidayHours = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingGoogleRankingProfileHolidayHours>>,
      TError,
      { data: PostMarketingGoogleRankingProfileHolidayHoursBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingGoogleRankingProfileHolidayHours>>,
  TError,
  { data: PostMarketingGoogleRankingProfileHolidayHoursBody },
  TContext
> => {
  const mutationOptions = getPostMarketingGoogleRankingProfileHolidayHoursMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Approve the listed fixes as Hayven proposed them (only this salon's OPEN ones are taken)
 */
export const postMarketingGoogleRankingProfileSuggestionsApproveAll = (
  postMarketingGoogleRankingProfileSuggestionsApproveAllBody: PostMarketingGoogleRankingProfileSuggestionsApproveAllBody,
  signal?: AbortSignal
) => {
  return customInstance<PostMarketingGoogleRankingProfileSuggestionsApproveAll200>({
    url: `/marketing/google-ranking/profile/suggestions/approve-all`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postMarketingGoogleRankingProfileSuggestionsApproveAllBody,
    signal,
  });
};

export const getPostMarketingGoogleRankingProfileSuggestionsApproveAllMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingGoogleRankingProfileSuggestionsApproveAll>>,
    TError,
    { data: PostMarketingGoogleRankingProfileSuggestionsApproveAllBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingGoogleRankingProfileSuggestionsApproveAll>>,
  TError,
  { data: PostMarketingGoogleRankingProfileSuggestionsApproveAllBody },
  TContext
> => {
  const mutationKey = ['postMarketingGoogleRankingProfileSuggestionsApproveAll'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingGoogleRankingProfileSuggestionsApproveAll>>,
    { data: PostMarketingGoogleRankingProfileSuggestionsApproveAllBody }
  > = (props) => {
    const { data } = props ?? {};

    return postMarketingGoogleRankingProfileSuggestionsApproveAll(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingGoogleRankingProfileSuggestionsApproveAllMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingGoogleRankingProfileSuggestionsApproveAll>>
>;
export type PostMarketingGoogleRankingProfileSuggestionsApproveAllMutationBody =
  PostMarketingGoogleRankingProfileSuggestionsApproveAllBody;
export type PostMarketingGoogleRankingProfileSuggestionsApproveAllMutationError = void;

/**
 * @summary Approve the listed fixes as Hayven proposed them (only this salon's OPEN ones are taken)
 */
export const usePostMarketingGoogleRankingProfileSuggestionsApproveAll = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingGoogleRankingProfileSuggestionsApproveAll>>,
      TError,
      { data: PostMarketingGoogleRankingProfileSuggestionsApproveAllBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingGoogleRankingProfileSuggestionsApproveAll>>,
  TError,
  { data: PostMarketingGoogleRankingProfileSuggestionsApproveAllBody },
  TContext
> => {
  const mutationOptions =
    getPostMarketingGoogleRankingProfileSuggestionsApproveAllMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Approve a fix (optionally edited) — queued and sent to Google; Google reviews it before it shows
 */
export const postMarketingGoogleRankingProfileSuggestionsIdApprove = (
  id: string,
  postMarketingGoogleRankingProfileSuggestionsIdApproveBody: PostMarketingGoogleRankingProfileSuggestionsIdApproveBody,
  signal?: AbortSignal
) => {
  return customInstance<PostMarketingGoogleRankingProfileSuggestionsIdApprove200>({
    url: `/marketing/google-ranking/profile/suggestions/${id}/approve`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postMarketingGoogleRankingProfileSuggestionsIdApproveBody,
    signal,
  });
};

export const getPostMarketingGoogleRankingProfileSuggestionsIdApproveMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingGoogleRankingProfileSuggestionsIdApprove>>,
    TError,
    { id: string; data: PostMarketingGoogleRankingProfileSuggestionsIdApproveBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingGoogleRankingProfileSuggestionsIdApprove>>,
  TError,
  { id: string; data: PostMarketingGoogleRankingProfileSuggestionsIdApproveBody },
  TContext
> => {
  const mutationKey = ['postMarketingGoogleRankingProfileSuggestionsIdApprove'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingGoogleRankingProfileSuggestionsIdApprove>>,
    { id: string; data: PostMarketingGoogleRankingProfileSuggestionsIdApproveBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return postMarketingGoogleRankingProfileSuggestionsIdApprove(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingGoogleRankingProfileSuggestionsIdApproveMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingGoogleRankingProfileSuggestionsIdApprove>>
>;
export type PostMarketingGoogleRankingProfileSuggestionsIdApproveMutationBody =
  PostMarketingGoogleRankingProfileSuggestionsIdApproveBody;
export type PostMarketingGoogleRankingProfileSuggestionsIdApproveMutationError = void;

/**
 * @summary Approve a fix (optionally edited) — queued and sent to Google; Google reviews it before it shows
 */
export const usePostMarketingGoogleRankingProfileSuggestionsIdApprove = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingGoogleRankingProfileSuggestionsIdApprove>>,
      TError,
      { id: string; data: PostMarketingGoogleRankingProfileSuggestionsIdApproveBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingGoogleRankingProfileSuggestionsIdApprove>>,
  TError,
  { id: string; data: PostMarketingGoogleRankingProfileSuggestionsIdApproveBody },
  TContext
> => {
  const mutationOptions =
    getPostMarketingGoogleRankingProfileSuggestionsIdApproveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Skip a fix — Hayven never suggests these exact values again
 */
export const postMarketingGoogleRankingProfileSuggestionsIdSkip = (
  id: string,
  signal?: AbortSignal
) => {
  return customInstance<PostMarketingGoogleRankingProfileSuggestionsIdSkip200>({
    url: `/marketing/google-ranking/profile/suggestions/${id}/skip`,
    method: 'POST',
    signal,
  });
};

export const getPostMarketingGoogleRankingProfileSuggestionsIdSkipMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingGoogleRankingProfileSuggestionsIdSkip>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingGoogleRankingProfileSuggestionsIdSkip>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['postMarketingGoogleRankingProfileSuggestionsIdSkip'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingGoogleRankingProfileSuggestionsIdSkip>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return postMarketingGoogleRankingProfileSuggestionsIdSkip(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingGoogleRankingProfileSuggestionsIdSkipMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingGoogleRankingProfileSuggestionsIdSkip>>
>;

export type PostMarketingGoogleRankingProfileSuggestionsIdSkipMutationError = void;

/**
 * @summary Skip a fix — Hayven never suggests these exact values again
 */
export const usePostMarketingGoogleRankingProfileSuggestionsIdSkip = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingGoogleRankingProfileSuggestionsIdSkip>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingGoogleRankingProfileSuggestionsIdSkip>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions =
    getPostMarketingGoogleRankingProfileSuggestionsIdSkipMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Maps rank grid for one keyword: latest scan, 4-week trend, history, scan state (database only)
 */
export const getMarketingGoogleRankingRank = (
  params?: GetMarketingGoogleRankingRankParams,
  signal?: AbortSignal
) => {
  return customInstance<GetMarketingGoogleRankingRank200>({
    url: `/marketing/google-ranking/rank`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetMarketingGoogleRankingRankInfiniteQueryKey = (
  params?: GetMarketingGoogleRankingRankParams
) => {
  return ['infinite', `/marketing/google-ranking/rank`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingGoogleRankingRankQueryKey = (
  params?: GetMarketingGoogleRankingRankParams
) => {
  return [`/marketing/google-ranking/rank`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingGoogleRankingRankInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingRank>>>,
  TError = void,
>(
  params?: GetMarketingGoogleRankingRankParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingRank>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingGoogleRankingRankInfiniteQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingGoogleRankingRank>>> = ({
    signal,
  }) => getMarketingGoogleRankingRank(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingGoogleRankingRank>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingGoogleRankingRankInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingGoogleRankingRank>>
>;
export type GetMarketingGoogleRankingRankInfiniteQueryError = void;

export function useGetMarketingGoogleRankingRankInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingRank>>>,
  TError = void,
>(
  params: undefined | GetMarketingGoogleRankingRankParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingRank>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleRankingRank>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleRankingRank>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingRankInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingRank>>>,
  TError = void,
>(
  params?: GetMarketingGoogleRankingRankParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingRank>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleRankingRank>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleRankingRank>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingRankInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingRank>>>,
  TError = void,
>(
  params?: GetMarketingGoogleRankingRankParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingRank>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Maps rank grid for one keyword: latest scan, 4-week trend, history, scan state (database only)
 */

export function useGetMarketingGoogleRankingRankInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingRank>>>,
  TError = void,
>(
  params?: GetMarketingGoogleRankingRankParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingRank>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingGoogleRankingRankInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingGoogleRankingRankQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingRank>>,
  TError = void,
>(
  params?: GetMarketingGoogleRankingRankParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingGoogleRankingRank>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingGoogleRankingRankQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingGoogleRankingRank>>> = ({
    signal,
  }) => getMarketingGoogleRankingRank(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingGoogleRankingRank>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingGoogleRankingRankQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingGoogleRankingRank>>
>;
export type GetMarketingGoogleRankingRankQueryError = void;

export function useGetMarketingGoogleRankingRank<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingRank>>,
  TError = void,
>(
  params: undefined | GetMarketingGoogleRankingRankParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingGoogleRankingRank>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleRankingRank>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleRankingRank>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingRank<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingRank>>,
  TError = void,
>(
  params?: GetMarketingGoogleRankingRankParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingGoogleRankingRank>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleRankingRank>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleRankingRank>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingRank<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingRank>>,
  TError = void,
>(
  params?: GetMarketingGoogleRankingRankParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingGoogleRankingRank>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Maps rank grid for one keyword: latest scan, 4-week trend, history, scan state (database only)
 */

export function useGetMarketingGoogleRankingRank<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingRank>>,
  TError = void,
>(
  params?: GetMarketingGoogleRankingRankParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingGoogleRankingRank>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingGoogleRankingRankQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingGoogleRankingRankSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingRank>>,
  TError = void,
>(
  params?: GetMarketingGoogleRankingRankParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingRank>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingGoogleRankingRankQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingGoogleRankingRank>>> = ({
    signal,
  }) => getMarketingGoogleRankingRank(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingGoogleRankingRank>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingGoogleRankingRankSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingGoogleRankingRank>>
>;
export type GetMarketingGoogleRankingRankSuspenseQueryError = void;

export function useGetMarketingGoogleRankingRankSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingRank>>,
  TError = void,
>(
  params: undefined | GetMarketingGoogleRankingRankParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingRank>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingRankSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingRank>>,
  TError = void,
>(
  params?: GetMarketingGoogleRankingRankParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingRank>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingRankSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingRank>>,
  TError = void,
>(
  params?: GetMarketingGoogleRankingRankParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingRank>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Maps rank grid for one keyword: latest scan, 4-week trend, history, scan state (database only)
 */

export function useGetMarketingGoogleRankingRankSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingRank>>,
  TError = void,
>(
  params?: GetMarketingGoogleRankingRankParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingRank>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingGoogleRankingRankSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Street map of a scan's area, drawn under its rank grid (PNG; browser-cached only as long as Google allows)
 */
export const getMarketingGoogleRankingRankScansScanIdMap = (
  scanId: string,
  signal?: AbortSignal
) => {
  return customInstance<Blob>({
    url: `/marketing/google-ranking/rank/scans/${scanId}/map`,
    method: 'GET',
    responseType: 'blob',
    signal,
  });
};

export const getGetMarketingGoogleRankingRankScansScanIdMapInfiniteQueryKey = (scanId?: string) => {
  return ['infinite', `/marketing/google-ranking/rank/scans/${scanId}/map`] as const;
};

export const getGetMarketingGoogleRankingRankScansScanIdMapQueryKey = (scanId?: string) => {
  return [`/marketing/google-ranking/rank/scans/${scanId}/map`] as const;
};

export const getGetMarketingGoogleRankingRankScansScanIdMapInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingRankScansScanIdMap>>>,
  TError = void,
>(
  scanId: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingRankScansScanIdMap>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetMarketingGoogleRankingRankScansScanIdMapInfiniteQueryKey(scanId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingGoogleRankingRankScansScanIdMap>>
  > = ({ signal }) => getMarketingGoogleRankingRankScansScanIdMap(scanId, signal);

  return { queryKey, queryFn, enabled: !!scanId, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingGoogleRankingRankScansScanIdMap>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingGoogleRankingRankScansScanIdMapInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingGoogleRankingRankScansScanIdMap>>
>;
export type GetMarketingGoogleRankingRankScansScanIdMapInfiniteQueryError = void;

export function useGetMarketingGoogleRankingRankScansScanIdMapInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingRankScansScanIdMap>>>,
  TError = void,
>(
  scanId: string,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingRankScansScanIdMap>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleRankingRankScansScanIdMap>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleRankingRankScansScanIdMap>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingRankScansScanIdMapInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingRankScansScanIdMap>>>,
  TError = void,
>(
  scanId: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingRankScansScanIdMap>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleRankingRankScansScanIdMap>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleRankingRankScansScanIdMap>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingRankScansScanIdMapInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingRankScansScanIdMap>>>,
  TError = void,
>(
  scanId: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingRankScansScanIdMap>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Street map of a scan's area, drawn under its rank grid (PNG; browser-cached only as long as Google allows)
 */

export function useGetMarketingGoogleRankingRankScansScanIdMapInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingRankScansScanIdMap>>>,
  TError = void,
>(
  scanId: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingRankScansScanIdMap>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingGoogleRankingRankScansScanIdMapInfiniteQueryOptions(
    scanId,
    options
  );

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingGoogleRankingRankScansScanIdMapQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingRankScansScanIdMap>>,
  TError = void,
>(
  scanId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingRankScansScanIdMap>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingGoogleRankingRankScansScanIdMapQueryKey(scanId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingGoogleRankingRankScansScanIdMap>>
  > = ({ signal }) => getMarketingGoogleRankingRankScansScanIdMap(scanId, signal);

  return { queryKey, queryFn, enabled: !!scanId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingGoogleRankingRankScansScanIdMap>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingGoogleRankingRankScansScanIdMapQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingGoogleRankingRankScansScanIdMap>>
>;
export type GetMarketingGoogleRankingRankScansScanIdMapQueryError = void;

export function useGetMarketingGoogleRankingRankScansScanIdMap<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingRankScansScanIdMap>>,
  TError = void,
>(
  scanId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingRankScansScanIdMap>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleRankingRankScansScanIdMap>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleRankingRankScansScanIdMap>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingRankScansScanIdMap<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingRankScansScanIdMap>>,
  TError = void,
>(
  scanId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingRankScansScanIdMap>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleRankingRankScansScanIdMap>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleRankingRankScansScanIdMap>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingRankScansScanIdMap<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingRankScansScanIdMap>>,
  TError = void,
>(
  scanId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingRankScansScanIdMap>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Street map of a scan's area, drawn under its rank grid (PNG; browser-cached only as long as Google allows)
 */

export function useGetMarketingGoogleRankingRankScansScanIdMap<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingRankScansScanIdMap>>,
  TError = void,
>(
  scanId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingRankScansScanIdMap>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingGoogleRankingRankScansScanIdMapQueryOptions(scanId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingGoogleRankingRankScansScanIdMapSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingRankScansScanIdMap>>,
  TError = void,
>(
  scanId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingRankScansScanIdMap>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingGoogleRankingRankScansScanIdMapQueryKey(scanId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingGoogleRankingRankScansScanIdMap>>
  > = ({ signal }) => getMarketingGoogleRankingRankScansScanIdMap(scanId, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingGoogleRankingRankScansScanIdMap>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingGoogleRankingRankScansScanIdMapSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingGoogleRankingRankScansScanIdMap>>
>;
export type GetMarketingGoogleRankingRankScansScanIdMapSuspenseQueryError = void;

export function useGetMarketingGoogleRankingRankScansScanIdMapSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingRankScansScanIdMap>>,
  TError = void,
>(
  scanId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingRankScansScanIdMap>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingRankScansScanIdMapSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingRankScansScanIdMap>>,
  TError = void,
>(
  scanId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingRankScansScanIdMap>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingRankScansScanIdMapSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingRankScansScanIdMap>>,
  TError = void,
>(
  scanId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingRankScansScanIdMap>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Street map of a scan's area, drawn under its rank grid (PNG; browser-cached only as long as Google allows)
 */

export function useGetMarketingGoogleRankingRankScansScanIdMapSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingRankScansScanIdMap>>,
  TError = void,
>(
  scanId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingRankScansScanIdMap>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingGoogleRankingRankScansScanIdMapSuspenseQueryOptions(
    scanId,
    options
  );

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Tracked Maps keywords (defaults are added the first time a scannable salon looks)
 */
export const getMarketingGoogleRankingKeywords = (signal?: AbortSignal) => {
  return customInstance<GetMarketingGoogleRankingKeywords200>({
    url: `/marketing/google-ranking/keywords`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingGoogleRankingKeywordsInfiniteQueryKey = () => {
  return ['infinite', `/marketing/google-ranking/keywords`] as const;
};

export const getGetMarketingGoogleRankingKeywordsQueryKey = () => {
  return [`/marketing/google-ranking/keywords`] as const;
};

export const getGetMarketingGoogleRankingKeywordsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingKeywords>>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getMarketingGoogleRankingKeywords>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingGoogleRankingKeywordsInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingGoogleRankingKeywords>>> = ({
    signal,
  }) => getMarketingGoogleRankingKeywords(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingGoogleRankingKeywords>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingGoogleRankingKeywordsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingGoogleRankingKeywords>>
>;
export type GetMarketingGoogleRankingKeywordsInfiniteQueryError = void;

export function useGetMarketingGoogleRankingKeywordsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingKeywords>>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingKeywords>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleRankingKeywords>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleRankingKeywords>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingKeywordsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingKeywords>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingKeywords>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleRankingKeywords>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleRankingKeywords>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingKeywordsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingKeywords>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingKeywords>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Tracked Maps keywords (defaults are added the first time a scannable salon looks)
 */

export function useGetMarketingGoogleRankingKeywordsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingKeywords>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingKeywords>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingGoogleRankingKeywordsInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingGoogleRankingKeywordsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingKeywords>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getMarketingGoogleRankingKeywords>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingGoogleRankingKeywordsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingGoogleRankingKeywords>>> = ({
    signal,
  }) => getMarketingGoogleRankingKeywords(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingGoogleRankingKeywords>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingGoogleRankingKeywordsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingGoogleRankingKeywords>>
>;
export type GetMarketingGoogleRankingKeywordsQueryError = void;

export function useGetMarketingGoogleRankingKeywords<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingKeywords>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingGoogleRankingKeywords>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleRankingKeywords>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleRankingKeywords>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingKeywords<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingKeywords>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingGoogleRankingKeywords>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleRankingKeywords>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleRankingKeywords>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingKeywords<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingKeywords>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingGoogleRankingKeywords>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Tracked Maps keywords (defaults are added the first time a scannable salon looks)
 */

export function useGetMarketingGoogleRankingKeywords<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingKeywords>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingGoogleRankingKeywords>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingGoogleRankingKeywordsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingGoogleRankingKeywordsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingKeywords>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getMarketingGoogleRankingKeywords>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingGoogleRankingKeywordsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingGoogleRankingKeywords>>> = ({
    signal,
  }) => getMarketingGoogleRankingKeywords(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingGoogleRankingKeywords>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingGoogleRankingKeywordsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingGoogleRankingKeywords>>
>;
export type GetMarketingGoogleRankingKeywordsSuspenseQueryError = void;

export function useGetMarketingGoogleRankingKeywordsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingKeywords>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingKeywords>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingKeywordsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingKeywords>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingKeywords>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingKeywordsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingKeywords>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingKeywords>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Tracked Maps keywords (defaults are added the first time a scannable salon looks)
 */

export function useGetMarketingGoogleRankingKeywordsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingKeywords>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingKeywords>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingGoogleRankingKeywordsSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Track a keyword (up to the plan's limit) — its first map scan starts right away
 */
export const postMarketingGoogleRankingKeywords = (
  postMarketingGoogleRankingKeywordsBody: PostMarketingGoogleRankingKeywordsBody,
  signal?: AbortSignal
) => {
  return customInstance<PostMarketingGoogleRankingKeywords201>({
    url: `/marketing/google-ranking/keywords`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postMarketingGoogleRankingKeywordsBody,
    signal,
  });
};

export const getPostMarketingGoogleRankingKeywordsMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingGoogleRankingKeywords>>,
    TError,
    { data: PostMarketingGoogleRankingKeywordsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingGoogleRankingKeywords>>,
  TError,
  { data: PostMarketingGoogleRankingKeywordsBody },
  TContext
> => {
  const mutationKey = ['postMarketingGoogleRankingKeywords'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingGoogleRankingKeywords>>,
    { data: PostMarketingGoogleRankingKeywordsBody }
  > = (props) => {
    const { data } = props ?? {};

    return postMarketingGoogleRankingKeywords(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingGoogleRankingKeywordsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingGoogleRankingKeywords>>
>;
export type PostMarketingGoogleRankingKeywordsMutationBody = PostMarketingGoogleRankingKeywordsBody;
export type PostMarketingGoogleRankingKeywordsMutationError = void;

/**
 * @summary Track a keyword (up to the plan's limit) — its first map scan starts right away
 */
export const usePostMarketingGoogleRankingKeywords = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingGoogleRankingKeywords>>,
      TError,
      { data: PostMarketingGoogleRankingKeywordsBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingGoogleRankingKeywords>>,
  TError,
  { data: PostMarketingGoogleRankingKeywordsBody },
  TContext
> => {
  const mutationOptions = getPostMarketingGoogleRankingKeywordsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Stop tracking a keyword (its scan history is kept)
 */
export const deleteMarketingGoogleRankingKeywordsId = (id: string) => {
  return customInstance<DeleteMarketingGoogleRankingKeywordsId200>({
    url: `/marketing/google-ranking/keywords/${id}`,
    method: 'DELETE',
  });
};

export const getDeleteMarketingGoogleRankingKeywordsIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMarketingGoogleRankingKeywordsId>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMarketingGoogleRankingKeywordsId>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteMarketingGoogleRankingKeywordsId'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMarketingGoogleRankingKeywordsId>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteMarketingGoogleRankingKeywordsId(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMarketingGoogleRankingKeywordsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMarketingGoogleRankingKeywordsId>>
>;

export type DeleteMarketingGoogleRankingKeywordsIdMutationError = void;

/**
 * @summary Stop tracking a keyword (its scan history is kept)
 */
export const useDeleteMarketingGoogleRankingKeywordsId = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteMarketingGoogleRankingKeywordsId>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteMarketingGoogleRankingKeywordsId>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteMarketingGoogleRankingKeywordsIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary "Scan now" for one keyword (1 per keyword per 24 hours) — results in about an hour
 */
export const postMarketingGoogleRankingKeywordsIdScan = (id: string, signal?: AbortSignal) => {
  return customInstance<PostMarketingGoogleRankingKeywordsIdScan202>({
    url: `/marketing/google-ranking/keywords/${id}/scan`,
    method: 'POST',
    signal,
  });
};

export const getPostMarketingGoogleRankingKeywordsIdScanMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingGoogleRankingKeywordsIdScan>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingGoogleRankingKeywordsIdScan>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['postMarketingGoogleRankingKeywordsIdScan'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingGoogleRankingKeywordsIdScan>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return postMarketingGoogleRankingKeywordsIdScan(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingGoogleRankingKeywordsIdScanMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingGoogleRankingKeywordsIdScan>>
>;

export type PostMarketingGoogleRankingKeywordsIdScanMutationError = void;

/**
 * @summary "Scan now" for one keyword (1 per keyword per 24 hours) — results in about an hour
 */
export const usePostMarketingGoogleRankingKeywordsIdScan = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingGoogleRankingKeywordsIdScan>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingGoogleRankingKeywordsIdScan>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getPostMarketingGoogleRankingKeywordsIdScanMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Profile score, Maps rank card, "Do these next", review momentum and monthly Google report (database only)
 */
export const getMarketingGoogleRankingOverview = (signal?: AbortSignal) => {
  return customInstance<GetMarketingGoogleRankingOverview200>({
    url: `/marketing/google-ranking/overview`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingGoogleRankingOverviewInfiniteQueryKey = () => {
  return ['infinite', `/marketing/google-ranking/overview`] as const;
};

export const getGetMarketingGoogleRankingOverviewQueryKey = () => {
  return [`/marketing/google-ranking/overview`] as const;
};

export const getGetMarketingGoogleRankingOverviewInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingOverview>>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getMarketingGoogleRankingOverview>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingGoogleRankingOverviewInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingGoogleRankingOverview>>> = ({
    signal,
  }) => getMarketingGoogleRankingOverview(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingGoogleRankingOverview>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingGoogleRankingOverviewInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingGoogleRankingOverview>>
>;
export type GetMarketingGoogleRankingOverviewInfiniteQueryError = void;

export function useGetMarketingGoogleRankingOverviewInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingOverview>>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingOverview>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleRankingOverview>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleRankingOverview>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingOverviewInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingOverview>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingOverview>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleRankingOverview>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleRankingOverview>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingOverviewInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingOverview>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingOverview>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Profile score, Maps rank card, "Do these next", review momentum and monthly Google report (database only)
 */

export function useGetMarketingGoogleRankingOverviewInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingOverview>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingOverview>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingGoogleRankingOverviewInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingGoogleRankingOverviewQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingOverview>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getMarketingGoogleRankingOverview>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingGoogleRankingOverviewQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingGoogleRankingOverview>>> = ({
    signal,
  }) => getMarketingGoogleRankingOverview(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingGoogleRankingOverview>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingGoogleRankingOverviewQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingGoogleRankingOverview>>
>;
export type GetMarketingGoogleRankingOverviewQueryError = void;

export function useGetMarketingGoogleRankingOverview<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingOverview>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingGoogleRankingOverview>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleRankingOverview>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleRankingOverview>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingOverview<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingOverview>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingGoogleRankingOverview>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleRankingOverview>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleRankingOverview>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingOverview<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingOverview>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingGoogleRankingOverview>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Profile score, Maps rank card, "Do these next", review momentum and monthly Google report (database only)
 */

export function useGetMarketingGoogleRankingOverview<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingOverview>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingGoogleRankingOverview>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingGoogleRankingOverviewQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingGoogleRankingOverviewSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingOverview>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getMarketingGoogleRankingOverview>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingGoogleRankingOverviewQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingGoogleRankingOverview>>> = ({
    signal,
  }) => getMarketingGoogleRankingOverview(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingGoogleRankingOverview>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingGoogleRankingOverviewSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingGoogleRankingOverview>>
>;
export type GetMarketingGoogleRankingOverviewSuspenseQueryError = void;

export function useGetMarketingGoogleRankingOverviewSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingOverview>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingOverview>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingOverviewSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingOverview>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingOverview>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingOverviewSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingOverview>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingOverview>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Profile score, Maps rank card, "Do these next", review momentum and monthly Google report (database only)
 */

export function useGetMarketingGoogleRankingOverviewSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingOverview>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingOverview>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingGoogleRankingOverviewSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Google posts: upcoming (waiting, approved, publishing, failed) or past (database only)
 */
export const getMarketingGoogleRankingPosts = (
  params?: GetMarketingGoogleRankingPostsParams,
  signal?: AbortSignal
) => {
  return customInstance<GetMarketingGoogleRankingPosts200>({
    url: `/marketing/google-ranking/posts`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetMarketingGoogleRankingPostsInfiniteQueryKey = (
  params?: GetMarketingGoogleRankingPostsParams
) => {
  return ['infinite', `/marketing/google-ranking/posts`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingGoogleRankingPostsQueryKey = (
  params?: GetMarketingGoogleRankingPostsParams
) => {
  return [`/marketing/google-ranking/posts`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingGoogleRankingPostsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingPosts>>>,
  TError = void,
>(
  params?: GetMarketingGoogleRankingPostsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPosts>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingGoogleRankingPostsInfiniteQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingGoogleRankingPosts>>> = ({
    signal,
  }) => getMarketingGoogleRankingPosts(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingGoogleRankingPosts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingGoogleRankingPostsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingGoogleRankingPosts>>
>;
export type GetMarketingGoogleRankingPostsInfiniteQueryError = void;

export function useGetMarketingGoogleRankingPostsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingPosts>>>,
  TError = void,
>(
  params: undefined | GetMarketingGoogleRankingPostsParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPosts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleRankingPosts>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleRankingPosts>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingPostsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingPosts>>>,
  TError = void,
>(
  params?: GetMarketingGoogleRankingPostsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPosts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleRankingPosts>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleRankingPosts>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingPostsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingPosts>>>,
  TError = void,
>(
  params?: GetMarketingGoogleRankingPostsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPosts>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Google posts: upcoming (waiting, approved, publishing, failed) or past (database only)
 */

export function useGetMarketingGoogleRankingPostsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingPosts>>>,
  TError = void,
>(
  params?: GetMarketingGoogleRankingPostsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPosts>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingGoogleRankingPostsInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingGoogleRankingPostsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPosts>>,
  TError = void,
>(
  params?: GetMarketingGoogleRankingPostsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingGoogleRankingPosts>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingGoogleRankingPostsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingGoogleRankingPosts>>> = ({
    signal,
  }) => getMarketingGoogleRankingPosts(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingGoogleRankingPosts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingGoogleRankingPostsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingGoogleRankingPosts>>
>;
export type GetMarketingGoogleRankingPostsQueryError = void;

export function useGetMarketingGoogleRankingPosts<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPosts>>,
  TError = void,
>(
  params: undefined | GetMarketingGoogleRankingPostsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingGoogleRankingPosts>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleRankingPosts>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleRankingPosts>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingPosts<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPosts>>,
  TError = void,
>(
  params?: GetMarketingGoogleRankingPostsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingGoogleRankingPosts>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleRankingPosts>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleRankingPosts>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingPosts<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPosts>>,
  TError = void,
>(
  params?: GetMarketingGoogleRankingPostsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingGoogleRankingPosts>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Google posts: upcoming (waiting, approved, publishing, failed) or past (database only)
 */

export function useGetMarketingGoogleRankingPosts<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPosts>>,
  TError = void,
>(
  params?: GetMarketingGoogleRankingPostsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingGoogleRankingPosts>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingGoogleRankingPostsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingGoogleRankingPostsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPosts>>,
  TError = void,
>(
  params?: GetMarketingGoogleRankingPostsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPosts>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingGoogleRankingPostsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingGoogleRankingPosts>>> = ({
    signal,
  }) => getMarketingGoogleRankingPosts(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingGoogleRankingPosts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingGoogleRankingPostsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingGoogleRankingPosts>>
>;
export type GetMarketingGoogleRankingPostsSuspenseQueryError = void;

export function useGetMarketingGoogleRankingPostsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPosts>>,
  TError = void,
>(
  params: undefined | GetMarketingGoogleRankingPostsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPosts>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingPostsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPosts>>,
  TError = void,
>(
  params?: GetMarketingGoogleRankingPostsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPosts>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingPostsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPosts>>,
  TError = void,
>(
  params?: GetMarketingGoogleRankingPostsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPosts>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Google posts: upcoming (waiting, approved, publishing, failed) or past (database only)
 */

export function useGetMarketingGoogleRankingPostsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPosts>>,
  TError = void,
>(
  params?: GetMarketingGoogleRankingPostsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPosts>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingGoogleRankingPostsSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Write a post — it is scheduled for its time as saved (right away when that has passed)
 */
export const postMarketingGoogleRankingPosts = (
  postMarketingGoogleRankingPostsBody: PostMarketingGoogleRankingPostsBody,
  signal?: AbortSignal
) => {
  return customInstance<PostMarketingGoogleRankingPosts201>({
    url: `/marketing/google-ranking/posts`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postMarketingGoogleRankingPostsBody,
    signal,
  });
};

export const getPostMarketingGoogleRankingPostsMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingGoogleRankingPosts>>,
    TError,
    { data: PostMarketingGoogleRankingPostsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingGoogleRankingPosts>>,
  TError,
  { data: PostMarketingGoogleRankingPostsBody },
  TContext
> => {
  const mutationKey = ['postMarketingGoogleRankingPosts'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingGoogleRankingPosts>>,
    { data: PostMarketingGoogleRankingPostsBody }
  > = (props) => {
    const { data } = props ?? {};

    return postMarketingGoogleRankingPosts(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingGoogleRankingPostsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingGoogleRankingPosts>>
>;
export type PostMarketingGoogleRankingPostsMutationBody = PostMarketingGoogleRankingPostsBody;
export type PostMarketingGoogleRankingPostsMutationError = void;

/**
 * @summary Write a post — it is scheduled for its time as saved (right away when that has passed)
 */
export const usePostMarketingGoogleRankingPosts = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingGoogleRankingPosts>>,
      TError,
      { data: PostMarketingGoogleRankingPostsBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingGoogleRankingPosts>>,
  TError,
  { data: PostMarketingGoogleRankingPostsBody },
  TContext
> => {
  const mutationOptions = getPostMarketingGoogleRankingPostsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Edit a post that is waiting, approved, failed or rejected (an approved post stays approved)
 */
export const patchMarketingGoogleRankingPostsPostId = (
  postId: string,
  patchMarketingGoogleRankingPostsPostIdBody: PatchMarketingGoogleRankingPostsPostIdBody
) => {
  return customInstance<PatchMarketingGoogleRankingPostsPostId200>({
    url: `/marketing/google-ranking/posts/${postId}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchMarketingGoogleRankingPostsPostIdBody,
  });
};

export const getPatchMarketingGoogleRankingPostsPostIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchMarketingGoogleRankingPostsPostId>>,
    TError,
    { postId: string; data: PatchMarketingGoogleRankingPostsPostIdBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchMarketingGoogleRankingPostsPostId>>,
  TError,
  { postId: string; data: PatchMarketingGoogleRankingPostsPostIdBody },
  TContext
> => {
  const mutationKey = ['patchMarketingGoogleRankingPostsPostId'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchMarketingGoogleRankingPostsPostId>>,
    { postId: string; data: PatchMarketingGoogleRankingPostsPostIdBody }
  > = (props) => {
    const { postId, data } = props ?? {};

    return patchMarketingGoogleRankingPostsPostId(postId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchMarketingGoogleRankingPostsPostIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchMarketingGoogleRankingPostsPostId>>
>;
export type PatchMarketingGoogleRankingPostsPostIdMutationBody =
  PatchMarketingGoogleRankingPostsPostIdBody;
export type PatchMarketingGoogleRankingPostsPostIdMutationError = void;

/**
 * @summary Edit a post that is waiting, approved, failed or rejected (an approved post stays approved)
 */
export const usePatchMarketingGoogleRankingPostsPostId = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchMarketingGoogleRankingPostsPostId>>,
      TError,
      { postId: string; data: PatchMarketingGoogleRankingPostsPostIdBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof patchMarketingGoogleRankingPostsPostId>>,
  TError,
  { postId: string; data: PatchMarketingGoogleRankingPostsPostIdBody },
  TContext
> => {
  const mutationOptions = getPatchMarketingGoogleRankingPostsPostIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Cancel a post; a post that is on Google is deleted on Google too
 */
export const deleteMarketingGoogleRankingPostsPostId = (postId: string) => {
  return customInstance<DeleteMarketingGoogleRankingPostsPostId200>({
    url: `/marketing/google-ranking/posts/${postId}`,
    method: 'DELETE',
  });
};

export const getDeleteMarketingGoogleRankingPostsPostIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMarketingGoogleRankingPostsPostId>>,
    TError,
    { postId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMarketingGoogleRankingPostsPostId>>,
  TError,
  { postId: string },
  TContext
> => {
  const mutationKey = ['deleteMarketingGoogleRankingPostsPostId'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMarketingGoogleRankingPostsPostId>>,
    { postId: string }
  > = (props) => {
    const { postId } = props ?? {};

    return deleteMarketingGoogleRankingPostsPostId(postId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMarketingGoogleRankingPostsPostIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMarketingGoogleRankingPostsPostId>>
>;

export type DeleteMarketingGoogleRankingPostsPostIdMutationError = void;

/**
 * @summary Cancel a post; a post that is on Google is deleted on Google too
 */
export const useDeleteMarketingGoogleRankingPostsPostId = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteMarketingGoogleRankingPostsPostId>>,
      TError,
      { postId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteMarketingGoogleRankingPostsPostId>>,
  TError,
  { postId: string },
  TContext
> => {
  const mutationOptions = getDeleteMarketingGoogleRankingPostsPostIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Approve a post (optionally with last edits) — it is published at its time, or right away if passed
 */
export const postMarketingGoogleRankingPostsPostIdApprove = (
  postId: string,
  postMarketingGoogleRankingPostsPostIdApproveBody: PostMarketingGoogleRankingPostsPostIdApproveBody,
  signal?: AbortSignal
) => {
  return customInstance<PostMarketingGoogleRankingPostsPostIdApprove200>({
    url: `/marketing/google-ranking/posts/${postId}/approve`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postMarketingGoogleRankingPostsPostIdApproveBody,
    signal,
  });
};

export const getPostMarketingGoogleRankingPostsPostIdApproveMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingGoogleRankingPostsPostIdApprove>>,
    TError,
    { postId: string; data: PostMarketingGoogleRankingPostsPostIdApproveBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingGoogleRankingPostsPostIdApprove>>,
  TError,
  { postId: string; data: PostMarketingGoogleRankingPostsPostIdApproveBody },
  TContext
> => {
  const mutationKey = ['postMarketingGoogleRankingPostsPostIdApprove'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingGoogleRankingPostsPostIdApprove>>,
    { postId: string; data: PostMarketingGoogleRankingPostsPostIdApproveBody }
  > = (props) => {
    const { postId, data } = props ?? {};

    return postMarketingGoogleRankingPostsPostIdApprove(postId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingGoogleRankingPostsPostIdApproveMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingGoogleRankingPostsPostIdApprove>>
>;
export type PostMarketingGoogleRankingPostsPostIdApproveMutationBody =
  PostMarketingGoogleRankingPostsPostIdApproveBody;
export type PostMarketingGoogleRankingPostsPostIdApproveMutationError = void;

/**
 * @summary Approve a post (optionally with last edits) — it is published at its time, or right away if passed
 */
export const usePostMarketingGoogleRankingPostsPostIdApprove = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingGoogleRankingPostsPostIdApprove>>,
      TError,
      { postId: string; data: PostMarketingGoogleRankingPostsPostIdApproveBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingGoogleRankingPostsPostIdApprove>>,
  TError,
  { postId: string; data: PostMarketingGoogleRankingPostsPostIdApproveBody },
  TContext
> => {
  const mutationOptions = getPostMarketingGoogleRankingPostsPostIdApproveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Take back the approval of a manual post — it waits for approval again (not for autopilot posts)
 */
export const postMarketingGoogleRankingPostsPostIdUnschedule = (
  postId: string,
  signal?: AbortSignal
) => {
  return customInstance<PostMarketingGoogleRankingPostsPostIdUnschedule200>({
    url: `/marketing/google-ranking/posts/${postId}/unschedule`,
    method: 'POST',
    signal,
  });
};

export const getPostMarketingGoogleRankingPostsPostIdUnscheduleMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingGoogleRankingPostsPostIdUnschedule>>,
    TError,
    { postId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingGoogleRankingPostsPostIdUnschedule>>,
  TError,
  { postId: string },
  TContext
> => {
  const mutationKey = ['postMarketingGoogleRankingPostsPostIdUnschedule'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingGoogleRankingPostsPostIdUnschedule>>,
    { postId: string }
  > = (props) => {
    const { postId } = props ?? {};

    return postMarketingGoogleRankingPostsPostIdUnschedule(postId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingGoogleRankingPostsPostIdUnscheduleMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingGoogleRankingPostsPostIdUnschedule>>
>;

export type PostMarketingGoogleRankingPostsPostIdUnscheduleMutationError = void;

/**
 * @summary Take back the approval of a manual post — it waits for approval again (not for autopilot posts)
 */
export const usePostMarketingGoogleRankingPostsPostIdUnschedule = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingGoogleRankingPostsPostIdUnschedule>>,
      TError,
      { postId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingGoogleRankingPostsPostIdUnschedule>>,
  TError,
  { postId: string },
  TContext
> => {
  const mutationOptions =
    getPostMarketingGoogleRankingPostsPostIdUnscheduleMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary What a post can link to and show: booking / Bio Page links, library photos and running campaigns with their photos
 */
export const getMarketingGoogleRankingPostEditorOptions = (signal?: AbortSignal) => {
  return customInstance<GetMarketingGoogleRankingPostEditorOptions200>({
    url: `/marketing/google-ranking/post-editor-options`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingGoogleRankingPostEditorOptionsInfiniteQueryKey = () => {
  return ['infinite', `/marketing/google-ranking/post-editor-options`] as const;
};

export const getGetMarketingGoogleRankingPostEditorOptionsQueryKey = () => {
  return [`/marketing/google-ranking/post-editor-options`] as const;
};

export const getGetMarketingGoogleRankingPostEditorOptionsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingPostEditorOptions>>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getMarketingGoogleRankingPostEditorOptions>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingGoogleRankingPostEditorOptionsInfiniteQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingGoogleRankingPostEditorOptions>>
  > = ({ signal }) => getMarketingGoogleRankingPostEditorOptions(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingGoogleRankingPostEditorOptions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingGoogleRankingPostEditorOptionsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingGoogleRankingPostEditorOptions>>
>;
export type GetMarketingGoogleRankingPostEditorOptionsInfiniteQueryError = void;

export function useGetMarketingGoogleRankingPostEditorOptionsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingPostEditorOptions>>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPostEditorOptions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleRankingPostEditorOptions>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleRankingPostEditorOptions>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingPostEditorOptionsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingPostEditorOptions>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPostEditorOptions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleRankingPostEditorOptions>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleRankingPostEditorOptions>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingPostEditorOptionsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingPostEditorOptions>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPostEditorOptions>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary What a post can link to and show: booking / Bio Page links, library photos and running campaigns with their photos
 */

export function useGetMarketingGoogleRankingPostEditorOptionsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingPostEditorOptions>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPostEditorOptions>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingGoogleRankingPostEditorOptionsInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingGoogleRankingPostEditorOptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPostEditorOptions>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getMarketingGoogleRankingPostEditorOptions>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingGoogleRankingPostEditorOptionsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingGoogleRankingPostEditorOptions>>
  > = ({ signal }) => getMarketingGoogleRankingPostEditorOptions(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingGoogleRankingPostEditorOptions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingGoogleRankingPostEditorOptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingGoogleRankingPostEditorOptions>>
>;
export type GetMarketingGoogleRankingPostEditorOptionsQueryError = void;

export function useGetMarketingGoogleRankingPostEditorOptions<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPostEditorOptions>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPostEditorOptions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleRankingPostEditorOptions>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleRankingPostEditorOptions>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingPostEditorOptions<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPostEditorOptions>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPostEditorOptions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleRankingPostEditorOptions>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleRankingPostEditorOptions>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingPostEditorOptions<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPostEditorOptions>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPostEditorOptions>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary What a post can link to and show: booking / Bio Page links, library photos and running campaigns with their photos
 */

export function useGetMarketingGoogleRankingPostEditorOptions<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPostEditorOptions>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPostEditorOptions>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingGoogleRankingPostEditorOptionsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingGoogleRankingPostEditorOptionsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPostEditorOptions>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getMarketingGoogleRankingPostEditorOptions>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingGoogleRankingPostEditorOptionsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingGoogleRankingPostEditorOptions>>
  > = ({ signal }) => getMarketingGoogleRankingPostEditorOptions(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingGoogleRankingPostEditorOptions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingGoogleRankingPostEditorOptionsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingGoogleRankingPostEditorOptions>>
>;
export type GetMarketingGoogleRankingPostEditorOptionsSuspenseQueryError = void;

export function useGetMarketingGoogleRankingPostEditorOptionsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPostEditorOptions>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPostEditorOptions>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingPostEditorOptionsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPostEditorOptions>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPostEditorOptions>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingPostEditorOptionsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPostEditorOptions>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPostEditorOptions>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary What a post can link to and show: booking / Bio Page links, library photos and running campaigns with their photos
 */

export function useGetMarketingGoogleRankingPostEditorOptionsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPostEditorOptions>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPostEditorOptions>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingGoogleRankingPostEditorOptionsSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Posts autopilot: on/off, posts per week, weekday and salon-local hour
 */
export const getMarketingGoogleRankingPostSettings = (signal?: AbortSignal) => {
  return customInstance<GetMarketingGoogleRankingPostSettings200>({
    url: `/marketing/google-ranking/post-settings`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingGoogleRankingPostSettingsInfiniteQueryKey = () => {
  return ['infinite', `/marketing/google-ranking/post-settings`] as const;
};

export const getGetMarketingGoogleRankingPostSettingsQueryKey = () => {
  return [`/marketing/google-ranking/post-settings`] as const;
};

export const getGetMarketingGoogleRankingPostSettingsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingPostSettings>>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getMarketingGoogleRankingPostSettings>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingGoogleRankingPostSettingsInfiniteQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingGoogleRankingPostSettings>>
  > = ({ signal }) => getMarketingGoogleRankingPostSettings(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingGoogleRankingPostSettings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingGoogleRankingPostSettingsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingGoogleRankingPostSettings>>
>;
export type GetMarketingGoogleRankingPostSettingsInfiniteQueryError = void;

export function useGetMarketingGoogleRankingPostSettingsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingPostSettings>>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPostSettings>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleRankingPostSettings>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleRankingPostSettings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingPostSettingsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingPostSettings>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPostSettings>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleRankingPostSettings>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleRankingPostSettings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingPostSettingsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingPostSettings>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPostSettings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Posts autopilot: on/off, posts per week, weekday and salon-local hour
 */

export function useGetMarketingGoogleRankingPostSettingsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingPostSettings>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPostSettings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingGoogleRankingPostSettingsInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingGoogleRankingPostSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPostSettings>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getMarketingGoogleRankingPostSettings>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingGoogleRankingPostSettingsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingGoogleRankingPostSettings>>
  > = ({ signal }) => getMarketingGoogleRankingPostSettings(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingGoogleRankingPostSettings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingGoogleRankingPostSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingGoogleRankingPostSettings>>
>;
export type GetMarketingGoogleRankingPostSettingsQueryError = void;

export function useGetMarketingGoogleRankingPostSettings<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPostSettings>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPostSettings>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleRankingPostSettings>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleRankingPostSettings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingPostSettings<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPostSettings>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPostSettings>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleRankingPostSettings>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleRankingPostSettings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingPostSettings<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPostSettings>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPostSettings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Posts autopilot: on/off, posts per week, weekday and salon-local hour
 */

export function useGetMarketingGoogleRankingPostSettings<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPostSettings>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPostSettings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingGoogleRankingPostSettingsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingGoogleRankingPostSettingsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPostSettings>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getMarketingGoogleRankingPostSettings>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingGoogleRankingPostSettingsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingGoogleRankingPostSettings>>
  > = ({ signal }) => getMarketingGoogleRankingPostSettings(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingGoogleRankingPostSettings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingGoogleRankingPostSettingsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingGoogleRankingPostSettings>>
>;
export type GetMarketingGoogleRankingPostSettingsSuspenseQueryError = void;

export function useGetMarketingGoogleRankingPostSettingsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPostSettings>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPostSettings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingPostSettingsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPostSettings>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPostSettings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingPostSettingsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPostSettings>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPostSettings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Posts autopilot: on/off, posts per week, weekday and salon-local hour
 */

export function useGetMarketingGoogleRankingPostSettingsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPostSettings>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPostSettings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingGoogleRankingPostSettingsSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update the autopilot (future autopilot posts follow the new schedule; off cancels them and unplans photos)
 */
export const patchMarketingGoogleRankingPostSettings = (
  patchMarketingGoogleRankingPostSettingsBody: PatchMarketingGoogleRankingPostSettingsBody
) => {
  return customInstance<PatchMarketingGoogleRankingPostSettings200>({
    url: `/marketing/google-ranking/post-settings`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchMarketingGoogleRankingPostSettingsBody,
  });
};

export const getPatchMarketingGoogleRankingPostSettingsMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchMarketingGoogleRankingPostSettings>>,
    TError,
    { data: PatchMarketingGoogleRankingPostSettingsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchMarketingGoogleRankingPostSettings>>,
  TError,
  { data: PatchMarketingGoogleRankingPostSettingsBody },
  TContext
> => {
  const mutationKey = ['patchMarketingGoogleRankingPostSettings'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchMarketingGoogleRankingPostSettings>>,
    { data: PatchMarketingGoogleRankingPostSettingsBody }
  > = (props) => {
    const { data } = props ?? {};

    return patchMarketingGoogleRankingPostSettings(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchMarketingGoogleRankingPostSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchMarketingGoogleRankingPostSettings>>
>;
export type PatchMarketingGoogleRankingPostSettingsMutationBody =
  PatchMarketingGoogleRankingPostSettingsBody;
export type PatchMarketingGoogleRankingPostSettingsMutationError = void;

/**
 * @summary Update the autopilot (future autopilot posts follow the new schedule; off cancels them and unplans photos)
 */
export const usePatchMarketingGoogleRankingPostSettings = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchMarketingGoogleRankingPostSettings>>,
      TError,
      { data: PatchMarketingGoogleRankingPostSettingsBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof patchMarketingGoogleRankingPostSettings>>,
  TError,
  { data: PatchMarketingGoogleRankingPostSettingsBody },
  TContext
> => {
  const mutationOptions = getPatchMarketingGoogleRankingPostSettingsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary One tab of the photo library (ready / on Google / skipped / removed), 60 per page
 */
export const getMarketingGoogleRankingPhotos = (
  params?: GetMarketingGoogleRankingPhotosParams,
  signal?: AbortSignal
) => {
  return customInstance<GetMarketingGoogleRankingPhotos200>({
    url: `/marketing/google-ranking/photos`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetMarketingGoogleRankingPhotosInfiniteQueryKey = (
  params?: GetMarketingGoogleRankingPhotosParams
) => {
  return ['infinite', `/marketing/google-ranking/photos`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingGoogleRankingPhotosQueryKey = (
  params?: GetMarketingGoogleRankingPhotosParams
) => {
  return [`/marketing/google-ranking/photos`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingGoogleRankingPhotosInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingPhotos>>>,
  TError = void,
>(
  params?: GetMarketingGoogleRankingPhotosParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPhotos>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingGoogleRankingPhotosInfiniteQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingGoogleRankingPhotos>>> = ({
    signal,
  }) => getMarketingGoogleRankingPhotos(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingGoogleRankingPhotos>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingGoogleRankingPhotosInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingGoogleRankingPhotos>>
>;
export type GetMarketingGoogleRankingPhotosInfiniteQueryError = void;

export function useGetMarketingGoogleRankingPhotosInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingPhotos>>>,
  TError = void,
>(
  params: undefined | GetMarketingGoogleRankingPhotosParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPhotos>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleRankingPhotos>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleRankingPhotos>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingPhotosInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingPhotos>>>,
  TError = void,
>(
  params?: GetMarketingGoogleRankingPhotosParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPhotos>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleRankingPhotos>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleRankingPhotos>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingPhotosInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingPhotos>>>,
  TError = void,
>(
  params?: GetMarketingGoogleRankingPhotosParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPhotos>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary One tab of the photo library (ready / on Google / skipped / removed), 60 per page
 */

export function useGetMarketingGoogleRankingPhotosInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingPhotos>>>,
  TError = void,
>(
  params?: GetMarketingGoogleRankingPhotosParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPhotos>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingGoogleRankingPhotosInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingGoogleRankingPhotosQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPhotos>>,
  TError = void,
>(
  params?: GetMarketingGoogleRankingPhotosParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingGoogleRankingPhotos>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingGoogleRankingPhotosQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingGoogleRankingPhotos>>> = ({
    signal,
  }) => getMarketingGoogleRankingPhotos(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingGoogleRankingPhotos>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingGoogleRankingPhotosQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingGoogleRankingPhotos>>
>;
export type GetMarketingGoogleRankingPhotosQueryError = void;

export function useGetMarketingGoogleRankingPhotos<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPhotos>>,
  TError = void,
>(
  params: undefined | GetMarketingGoogleRankingPhotosParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingGoogleRankingPhotos>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleRankingPhotos>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleRankingPhotos>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingPhotos<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPhotos>>,
  TError = void,
>(
  params?: GetMarketingGoogleRankingPhotosParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingGoogleRankingPhotos>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleRankingPhotos>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleRankingPhotos>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingPhotos<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPhotos>>,
  TError = void,
>(
  params?: GetMarketingGoogleRankingPhotosParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingGoogleRankingPhotos>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary One tab of the photo library (ready / on Google / skipped / removed), 60 per page
 */

export function useGetMarketingGoogleRankingPhotos<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPhotos>>,
  TError = void,
>(
  params?: GetMarketingGoogleRankingPhotosParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingGoogleRankingPhotos>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingGoogleRankingPhotosQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingGoogleRankingPhotosSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPhotos>>,
  TError = void,
>(
  params?: GetMarketingGoogleRankingPhotosParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPhotos>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingGoogleRankingPhotosQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingGoogleRankingPhotos>>> = ({
    signal,
  }) => getMarketingGoogleRankingPhotos(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingGoogleRankingPhotos>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingGoogleRankingPhotosSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingGoogleRankingPhotos>>
>;
export type GetMarketingGoogleRankingPhotosSuspenseQueryError = void;

export function useGetMarketingGoogleRankingPhotosSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPhotos>>,
  TError = void,
>(
  params: undefined | GetMarketingGoogleRankingPhotosParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPhotos>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingPhotosSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPhotos>>,
  TError = void,
>(
  params?: GetMarketingGoogleRankingPhotosParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPhotos>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingPhotosSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPhotos>>,
  TError = void,
>(
  params?: GetMarketingGoogleRankingPhotosParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPhotos>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary One tab of the photo library (ready / on Google / skipped / removed), 60 per page
 */

export function useGetMarketingGoogleRankingPhotosSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPhotos>>,
  TError = void,
>(
  params?: GetMarketingGoogleRankingPhotosParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPhotos>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingGoogleRankingPhotosSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Add a photo to the library (JPG/PNG/WebP) — it is checked, then the autopilot sends it to Google
 */
export const postMarketingGoogleRankingPhotos = (
  postMarketingGoogleRankingPhotosBody: PostMarketingGoogleRankingPhotosBody,
  signal?: AbortSignal
) => {
  const formData = new FormData();
  formData.append(`image`, postMarketingGoogleRankingPhotosBody.image);
  if (postMarketingGoogleRankingPhotosBody.category !== undefined) {
    formData.append(`category`, postMarketingGoogleRankingPhotosBody.category);
  }

  return customInstance<PostMarketingGoogleRankingPhotos201>({
    url: `/marketing/google-ranking/photos`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal,
  });
};

export const getPostMarketingGoogleRankingPhotosMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingGoogleRankingPhotos>>,
    TError,
    { data: PostMarketingGoogleRankingPhotosBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingGoogleRankingPhotos>>,
  TError,
  { data: PostMarketingGoogleRankingPhotosBody },
  TContext
> => {
  const mutationKey = ['postMarketingGoogleRankingPhotos'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingGoogleRankingPhotos>>,
    { data: PostMarketingGoogleRankingPhotosBody }
  > = (props) => {
    const { data } = props ?? {};

    return postMarketingGoogleRankingPhotos(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingGoogleRankingPhotosMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingGoogleRankingPhotos>>
>;
export type PostMarketingGoogleRankingPhotosMutationBody = PostMarketingGoogleRankingPhotosBody;
export type PostMarketingGoogleRankingPhotosMutationError = void;

/**
 * @summary Add a photo to the library (JPG/PNG/WebP) — it is checked, then the autopilot sends it to Google
 */
export const usePostMarketingGoogleRankingPhotos = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingGoogleRankingPhotos>>,
      TError,
      { data: PostMarketingGoogleRankingPhotosBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingGoogleRankingPhotos>>,
  TError,
  { data: PostMarketingGoogleRankingPhotosBody },
  TContext
> => {
  const mutationOptions = getPostMarketingGoogleRankingPhotosMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Photo library at a glance: tab counts, weeks of photos left, Instagram source, Google freshness
 */
export const getMarketingGoogleRankingPhotosSummary = (signal?: AbortSignal) => {
  return customInstance<GetMarketingGoogleRankingPhotosSummary200>({
    url: `/marketing/google-ranking/photos/summary`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingGoogleRankingPhotosSummaryInfiniteQueryKey = () => {
  return ['infinite', `/marketing/google-ranking/photos/summary`] as const;
};

export const getGetMarketingGoogleRankingPhotosSummaryQueryKey = () => {
  return [`/marketing/google-ranking/photos/summary`] as const;
};

export const getGetMarketingGoogleRankingPhotosSummaryInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosSummary>>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosSummary>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingGoogleRankingPhotosSummaryInfiniteQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosSummary>>
  > = ({ signal }) => getMarketingGoogleRankingPhotosSummary(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingGoogleRankingPhotosSummaryInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosSummary>>
>;
export type GetMarketingGoogleRankingPhotosSummaryInfiniteQueryError = void;

export function useGetMarketingGoogleRankingPhotosSummaryInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosSummary>>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosSummary>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosSummary>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingPhotosSummaryInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosSummary>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosSummary>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosSummary>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingPhotosSummaryInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosSummary>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosSummary>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Photo library at a glance: tab counts, weeks of photos left, Instagram source, Google freshness
 */

export function useGetMarketingGoogleRankingPhotosSummaryInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosSummary>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosSummary>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingGoogleRankingPhotosSummaryInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingGoogleRankingPhotosSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosSummary>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosSummary>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingGoogleRankingPhotosSummaryQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosSummary>>
  > = ({ signal }) => getMarketingGoogleRankingPhotosSummary(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingGoogleRankingPhotosSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosSummary>>
>;
export type GetMarketingGoogleRankingPhotosSummaryQueryError = void;

export function useGetMarketingGoogleRankingPhotosSummary<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosSummary>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosSummary>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosSummary>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingPhotosSummary<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosSummary>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosSummary>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosSummary>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingPhotosSummary<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosSummary>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosSummary>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Photo library at a glance: tab counts, weeks of photos left, Instagram source, Google freshness
 */

export function useGetMarketingGoogleRankingPhotosSummary<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosSummary>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosSummary>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingGoogleRankingPhotosSummaryQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingGoogleRankingPhotosSummarySuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosSummary>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosSummary>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingGoogleRankingPhotosSummaryQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosSummary>>
  > = ({ signal }) => getMarketingGoogleRankingPhotosSummary(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingGoogleRankingPhotosSummarySuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosSummary>>
>;
export type GetMarketingGoogleRankingPhotosSummarySuspenseQueryError = void;

export function useGetMarketingGoogleRankingPhotosSummarySuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosSummary>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosSummary>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingPhotosSummarySuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosSummary>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosSummary>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingPhotosSummarySuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosSummary>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosSummary>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Photo library at a glance: tab counts, weeks of photos left, Instagram source, Google freshness
 */

export function useGetMarketingGoogleRankingPhotosSummarySuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosSummary>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosSummary>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingGoogleRankingPhotosSummarySuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Where each photo of a bulk upload stands (checking / ready / skipped + reason)
 */
export const getMarketingGoogleRankingPhotosStatus = (
  params: GetMarketingGoogleRankingPhotosStatusParams,
  signal?: AbortSignal
) => {
  return customInstance<GetMarketingGoogleRankingPhotosStatus200>({
    url: `/marketing/google-ranking/photos/status`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetMarketingGoogleRankingPhotosStatusInfiniteQueryKey = (
  params?: GetMarketingGoogleRankingPhotosStatusParams
) => {
  return [
    'infinite',
    `/marketing/google-ranking/photos/status`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetMarketingGoogleRankingPhotosStatusQueryKey = (
  params?: GetMarketingGoogleRankingPhotosStatusParams
) => {
  return [`/marketing/google-ranking/photos/status`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingGoogleRankingPhotosStatusInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosStatus>>>,
  TError = void,
>(
  params: GetMarketingGoogleRankingPhotosStatusParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosStatus>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingGoogleRankingPhotosStatusInfiniteQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosStatus>>
  > = ({ signal }) => getMarketingGoogleRankingPhotosStatus(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingGoogleRankingPhotosStatusInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosStatus>>
>;
export type GetMarketingGoogleRankingPhotosStatusInfiniteQueryError = void;

export function useGetMarketingGoogleRankingPhotosStatusInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosStatus>>>,
  TError = void,
>(
  params: GetMarketingGoogleRankingPhotosStatusParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosStatus>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosStatus>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingPhotosStatusInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosStatus>>>,
  TError = void,
>(
  params: GetMarketingGoogleRankingPhotosStatusParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosStatus>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosStatus>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingPhotosStatusInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosStatus>>>,
  TError = void,
>(
  params: GetMarketingGoogleRankingPhotosStatusParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosStatus>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Where each photo of a bulk upload stands (checking / ready / skipped + reason)
 */

export function useGetMarketingGoogleRankingPhotosStatusInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosStatus>>>,
  TError = void,
>(
  params: GetMarketingGoogleRankingPhotosStatusParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosStatus>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingGoogleRankingPhotosStatusInfiniteQueryOptions(
    params,
    options
  );

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingGoogleRankingPhotosStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosStatus>>,
  TError = void,
>(
  params: GetMarketingGoogleRankingPhotosStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosStatus>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingGoogleRankingPhotosStatusQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosStatus>>
  > = ({ signal }) => getMarketingGoogleRankingPhotosStatus(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingGoogleRankingPhotosStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosStatus>>
>;
export type GetMarketingGoogleRankingPhotosStatusQueryError = void;

export function useGetMarketingGoogleRankingPhotosStatus<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosStatus>>,
  TError = void,
>(
  params: GetMarketingGoogleRankingPhotosStatusParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosStatus>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosStatus>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingPhotosStatus<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosStatus>>,
  TError = void,
>(
  params: GetMarketingGoogleRankingPhotosStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosStatus>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosStatus>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingPhotosStatus<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosStatus>>,
  TError = void,
>(
  params: GetMarketingGoogleRankingPhotosStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosStatus>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Where each photo of a bulk upload stands (checking / ready / skipped + reason)
 */

export function useGetMarketingGoogleRankingPhotosStatus<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosStatus>>,
  TError = void,
>(
  params: GetMarketingGoogleRankingPhotosStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosStatus>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingGoogleRankingPhotosStatusQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingGoogleRankingPhotosStatusSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosStatus>>,
  TError = void,
>(
  params: GetMarketingGoogleRankingPhotosStatusParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosStatus>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingGoogleRankingPhotosStatusQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosStatus>>
  > = ({ signal }) => getMarketingGoogleRankingPhotosStatus(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingGoogleRankingPhotosStatusSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosStatus>>
>;
export type GetMarketingGoogleRankingPhotosStatusSuspenseQueryError = void;

export function useGetMarketingGoogleRankingPhotosStatusSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosStatus>>,
  TError = void,
>(
  params: GetMarketingGoogleRankingPhotosStatusParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosStatus>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingPhotosStatusSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosStatus>>,
  TError = void,
>(
  params: GetMarketingGoogleRankingPhotosStatusParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosStatus>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingPhotosStatusSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosStatus>>,
  TError = void,
>(
  params: GetMarketingGoogleRankingPhotosStatusParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosStatus>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Where each photo of a bulk upload stands (checking / ready / skipped + reason)
 */

export function useGetMarketingGoogleRankingPhotosStatusSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosStatus>>,
  TError = void,
>(
  params: GetMarketingGoogleRankingPhotosStatusParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingPhotosStatus>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingGoogleRankingPhotosStatusSuspenseQueryOptions(
    params,
    options
  );

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Send up to 5 ready library photos to Google now (library order, best first; planned photos keep their slot)
 */
export const postMarketingGoogleRankingPhotosSendNow = (
  postMarketingGoogleRankingPhotosSendNowBody: PostMarketingGoogleRankingPhotosSendNowBody,
  signal?: AbortSignal
) => {
  return customInstance<PostMarketingGoogleRankingPhotosSendNow202>({
    url: `/marketing/google-ranking/photos/send-now`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postMarketingGoogleRankingPhotosSendNowBody,
    signal,
  });
};

export const getPostMarketingGoogleRankingPhotosSendNowMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingGoogleRankingPhotosSendNow>>,
    TError,
    { data: PostMarketingGoogleRankingPhotosSendNowBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingGoogleRankingPhotosSendNow>>,
  TError,
  { data: PostMarketingGoogleRankingPhotosSendNowBody },
  TContext
> => {
  const mutationKey = ['postMarketingGoogleRankingPhotosSendNow'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingGoogleRankingPhotosSendNow>>,
    { data: PostMarketingGoogleRankingPhotosSendNowBody }
  > = (props) => {
    const { data } = props ?? {};

    return postMarketingGoogleRankingPhotosSendNow(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingGoogleRankingPhotosSendNowMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingGoogleRankingPhotosSendNow>>
>;
export type PostMarketingGoogleRankingPhotosSendNowMutationBody =
  PostMarketingGoogleRankingPhotosSendNowBody;
export type PostMarketingGoogleRankingPhotosSendNowMutationError = void;

/**
 * @summary Send up to 5 ready library photos to Google now (library order, best first; planned photos keep their slot)
 */
export const usePostMarketingGoogleRankingPhotosSendNow = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingGoogleRankingPhotosSendNow>>,
      TError,
      { data: PostMarketingGoogleRankingPhotosSendNowBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingGoogleRankingPhotosSendNow>>,
  TError,
  { data: PostMarketingGoogleRankingPhotosSendNowBody },
  TContext
> => {
  const mutationOptions = getPostMarketingGoogleRankingPhotosSendNowMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Take a ready (or still checking) photo out of the library — it will not go to Google
 */
export const postMarketingGoogleRankingPhotosPhotoIdRemove = (
  photoId: string,
  signal?: AbortSignal
) => {
  return customInstance<PostMarketingGoogleRankingPhotosPhotoIdRemove200>({
    url: `/marketing/google-ranking/photos/${photoId}/remove`,
    method: 'POST',
    signal,
  });
};

export const getPostMarketingGoogleRankingPhotosPhotoIdRemoveMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingGoogleRankingPhotosPhotoIdRemove>>,
    TError,
    { photoId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingGoogleRankingPhotosPhotoIdRemove>>,
  TError,
  { photoId: string },
  TContext
> => {
  const mutationKey = ['postMarketingGoogleRankingPhotosPhotoIdRemove'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingGoogleRankingPhotosPhotoIdRemove>>,
    { photoId: string }
  > = (props) => {
    const { photoId } = props ?? {};

    return postMarketingGoogleRankingPhotosPhotoIdRemove(photoId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingGoogleRankingPhotosPhotoIdRemoveMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingGoogleRankingPhotosPhotoIdRemove>>
>;

export type PostMarketingGoogleRankingPhotosPhotoIdRemoveMutationError = void;

/**
 * @summary Take a ready (or still checking) photo out of the library — it will not go to Google
 */
export const usePostMarketingGoogleRankingPhotosPhotoIdRemove = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingGoogleRankingPhotosPhotoIdRemove>>,
      TError,
      { photoId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingGoogleRankingPhotosPhotoIdRemove>>,
  TError,
  { photoId: string },
  TContext
> => {
  const mutationOptions = getPostMarketingGoogleRankingPhotosPhotoIdRemoveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Put a removed photo back in the library
 */
export const postMarketingGoogleRankingPhotosPhotoIdRestore = (
  photoId: string,
  signal?: AbortSignal
) => {
  return customInstance<PostMarketingGoogleRankingPhotosPhotoIdRestore200>({
    url: `/marketing/google-ranking/photos/${photoId}/restore`,
    method: 'POST',
    signal,
  });
};

export const getPostMarketingGoogleRankingPhotosPhotoIdRestoreMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingGoogleRankingPhotosPhotoIdRestore>>,
    TError,
    { photoId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingGoogleRankingPhotosPhotoIdRestore>>,
  TError,
  { photoId: string },
  TContext
> => {
  const mutationKey = ['postMarketingGoogleRankingPhotosPhotoIdRestore'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingGoogleRankingPhotosPhotoIdRestore>>,
    { photoId: string }
  > = (props) => {
    const { photoId } = props ?? {};

    return postMarketingGoogleRankingPhotosPhotoIdRestore(photoId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingGoogleRankingPhotosPhotoIdRestoreMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingGoogleRankingPhotosPhotoIdRestore>>
>;

export type PostMarketingGoogleRankingPhotosPhotoIdRestoreMutationError = void;

/**
 * @summary Put a removed photo back in the library
 */
export const usePostMarketingGoogleRankingPhotosPhotoIdRestore = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingGoogleRankingPhotosPhotoIdRestore>>,
      TError,
      { photoId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingGoogleRankingPhotosPhotoIdRestore>>,
  TError,
  { photoId: string },
  TContext
> => {
  const mutationOptions = getPostMarketingGoogleRankingPhotosPhotoIdRestoreMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Use a photo the check skipped (not for photos too small or unreadable for Google)
 */
export const postMarketingGoogleRankingPhotosPhotoIdUseAnyway = (
  photoId: string,
  signal?: AbortSignal
) => {
  return customInstance<PostMarketingGoogleRankingPhotosPhotoIdUseAnyway200>({
    url: `/marketing/google-ranking/photos/${photoId}/use-anyway`,
    method: 'POST',
    signal,
  });
};

export const getPostMarketingGoogleRankingPhotosPhotoIdUseAnywayMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingGoogleRankingPhotosPhotoIdUseAnyway>>,
    TError,
    { photoId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingGoogleRankingPhotosPhotoIdUseAnyway>>,
  TError,
  { photoId: string },
  TContext
> => {
  const mutationKey = ['postMarketingGoogleRankingPhotosPhotoIdUseAnyway'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingGoogleRankingPhotosPhotoIdUseAnyway>>,
    { photoId: string }
  > = (props) => {
    const { photoId } = props ?? {};

    return postMarketingGoogleRankingPhotosPhotoIdUseAnyway(photoId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingGoogleRankingPhotosPhotoIdUseAnywayMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingGoogleRankingPhotosPhotoIdUseAnyway>>
>;

export type PostMarketingGoogleRankingPhotosPhotoIdUseAnywayMutationError = void;

/**
 * @summary Use a photo the check skipped (not for photos too small or unreadable for Google)
 */
export const usePostMarketingGoogleRankingPhotosPhotoIdUseAnyway = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingGoogleRankingPhotosPhotoIdUseAnyway>>,
      TError,
      { photoId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingGoogleRankingPhotosPhotoIdUseAnyway>>,
  TError,
  { photoId: string },
  TContext
> => {
  const mutationOptions =
    getPostMarketingGoogleRankingPhotosPhotoIdUseAnywayMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Take a planned photo off Up next — it goes back to the library behind the others; the next photo takes the slot
 */
export const postMarketingGoogleRankingPhotosPhotoIdSkipSlot = (
  photoId: string,
  signal?: AbortSignal
) => {
  return customInstance<PostMarketingGoogleRankingPhotosPhotoIdSkipSlot200>({
    url: `/marketing/google-ranking/photos/${photoId}/skip-slot`,
    method: 'POST',
    signal,
  });
};

export const getPostMarketingGoogleRankingPhotosPhotoIdSkipSlotMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingGoogleRankingPhotosPhotoIdSkipSlot>>,
    TError,
    { photoId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingGoogleRankingPhotosPhotoIdSkipSlot>>,
  TError,
  { photoId: string },
  TContext
> => {
  const mutationKey = ['postMarketingGoogleRankingPhotosPhotoIdSkipSlot'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingGoogleRankingPhotosPhotoIdSkipSlot>>,
    { photoId: string }
  > = (props) => {
    const { photoId } = props ?? {};

    return postMarketingGoogleRankingPhotosPhotoIdSkipSlot(photoId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingGoogleRankingPhotosPhotoIdSkipSlotMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingGoogleRankingPhotosPhotoIdSkipSlot>>
>;

export type PostMarketingGoogleRankingPhotosPhotoIdSkipSlotMutationError = void;

/**
 * @summary Take a planned photo off Up next — it goes back to the library behind the others; the next photo takes the slot
 */
export const usePostMarketingGoogleRankingPhotosPhotoIdSkipSlot = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingGoogleRankingPhotosPhotoIdSkipSlot>>,
      TError,
      { photoId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingGoogleRankingPhotosPhotoIdSkipSlot>>,
  TError,
  { photoId: string },
  TContext
> => {
  const mutationOptions =
    getPostMarketingGoogleRankingPhotosPhotoIdSkipSlotMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Send a failed (or stuck) photo to Google again
 */
export const postMarketingGoogleRankingPhotosPhotoIdRetry = (
  photoId: string,
  signal?: AbortSignal
) => {
  return customInstance<PostMarketingGoogleRankingPhotosPhotoIdRetry200>({
    url: `/marketing/google-ranking/photos/${photoId}/retry`,
    method: 'POST',
    signal,
  });
};

export const getPostMarketingGoogleRankingPhotosPhotoIdRetryMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingGoogleRankingPhotosPhotoIdRetry>>,
    TError,
    { photoId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingGoogleRankingPhotosPhotoIdRetry>>,
  TError,
  { photoId: string },
  TContext
> => {
  const mutationKey = ['postMarketingGoogleRankingPhotosPhotoIdRetry'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingGoogleRankingPhotosPhotoIdRetry>>,
    { photoId: string }
  > = (props) => {
    const { photoId } = props ?? {};

    return postMarketingGoogleRankingPhotosPhotoIdRetry(photoId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingGoogleRankingPhotosPhotoIdRetryMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingGoogleRankingPhotosPhotoIdRetry>>
>;

export type PostMarketingGoogleRankingPhotosPhotoIdRetryMutationError = void;

/**
 * @summary Send a failed (or stuck) photo to Google again
 */
export const usePostMarketingGoogleRankingPhotosPhotoIdRetry = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingGoogleRankingPhotosPhotoIdRetry>>,
      TError,
      { photoId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingGoogleRankingPhotosPhotoIdRetry>>,
  TError,
  { photoId: string },
  TContext
> => {
  const mutationOptions = getPostMarketingGoogleRankingPhotosPhotoIdRetryMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Photos and posts going to Google in the next two weeks, by time (no approval needed; owner can remove)
 */
export const getMarketingGoogleRankingUpNext = (signal?: AbortSignal) => {
  return customInstance<GetMarketingGoogleRankingUpNext200>({
    url: `/marketing/google-ranking/up-next`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingGoogleRankingUpNextInfiniteQueryKey = () => {
  return ['infinite', `/marketing/google-ranking/up-next`] as const;
};

export const getGetMarketingGoogleRankingUpNextQueryKey = () => {
  return [`/marketing/google-ranking/up-next`] as const;
};

export const getGetMarketingGoogleRankingUpNextInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingUpNext>>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getMarketingGoogleRankingUpNext>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingGoogleRankingUpNextInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingGoogleRankingUpNext>>> = ({
    signal,
  }) => getMarketingGoogleRankingUpNext(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingGoogleRankingUpNext>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingGoogleRankingUpNextInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingGoogleRankingUpNext>>
>;
export type GetMarketingGoogleRankingUpNextInfiniteQueryError = void;

export function useGetMarketingGoogleRankingUpNextInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingUpNext>>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingUpNext>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleRankingUpNext>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleRankingUpNext>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingUpNextInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingUpNext>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingUpNext>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleRankingUpNext>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleRankingUpNext>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingUpNextInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingUpNext>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingUpNext>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Photos and posts going to Google in the next two weeks, by time (no approval needed; owner can remove)
 */

export function useGetMarketingGoogleRankingUpNextInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleRankingUpNext>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingUpNext>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingGoogleRankingUpNextInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingGoogleRankingUpNextQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingUpNext>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getMarketingGoogleRankingUpNext>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingGoogleRankingUpNextQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingGoogleRankingUpNext>>> = ({
    signal,
  }) => getMarketingGoogleRankingUpNext(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingGoogleRankingUpNext>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingGoogleRankingUpNextQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingGoogleRankingUpNext>>
>;
export type GetMarketingGoogleRankingUpNextQueryError = void;

export function useGetMarketingGoogleRankingUpNext<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingUpNext>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingGoogleRankingUpNext>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleRankingUpNext>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleRankingUpNext>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingUpNext<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingUpNext>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingGoogleRankingUpNext>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleRankingUpNext>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleRankingUpNext>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingUpNext<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingUpNext>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingGoogleRankingUpNext>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Photos and posts going to Google in the next two weeks, by time (no approval needed; owner can remove)
 */

export function useGetMarketingGoogleRankingUpNext<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingUpNext>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingGoogleRankingUpNext>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingGoogleRankingUpNextQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingGoogleRankingUpNextSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingUpNext>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getMarketingGoogleRankingUpNext>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingGoogleRankingUpNextQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingGoogleRankingUpNext>>> = ({
    signal,
  }) => getMarketingGoogleRankingUpNext(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingGoogleRankingUpNext>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingGoogleRankingUpNextSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingGoogleRankingUpNext>>
>;
export type GetMarketingGoogleRankingUpNextSuspenseQueryError = void;

export function useGetMarketingGoogleRankingUpNextSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingUpNext>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingUpNext>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingUpNextSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingUpNext>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingUpNext>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleRankingUpNextSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingUpNext>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingUpNext>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Photos and posts going to Google in the next two weeks, by time (no approval needed; owner can remove)
 */

export function useGetMarketingGoogleRankingUpNextSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleRankingUpNext>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleRankingUpNext>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingGoogleRankingUpNextSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
